<template>
  <div
    id="app-preview"
    aria-hidden="true"
  >
    <div
      v-if="store.mockup"
      :style="{'margin-top':($vuetify.breakpoint.smAndDown ? '0' : '80px')}"
      class="iphone_mock hidden-xs"
      style="display:inline-block;"
      v-html="store.mockup"
    />
    <div class="web_mock hidden-sm-and-down">
      <div class="web_chrome">
        <span class="web_circle" />
        <span class="web_circle" />
        <span class="web_circle" />
      </div>
      <div class="secondary web_bar" />
      <div class="web_image">
        <h1 class="title text-xs-right pt-6 mr-6 white--text">
          THE TOOLS YOU NEED
        </h1>
      </div>
      <div
        v-if="store.borrowerWebContent"
        class="web_list mt-5"
      >
        <ul>
          <span
            v-for="tool in store.borrowerWebContent.splashBullets"
            :key="tool"
          >
            <li class="body-2 light ml-5 grey--text text--darken-1">
              {{ tool }}
            </li>
          </span>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppPreview',
  data () {
    return {
      store: this.$store
    }
  }
}
</script>

<style scoped>
.iphone_mock {
  color: #888;
  height:420px;
  line-height:20px;
  margin-top:200px;
  margin-left:0px;
  position:absolute;
  z-index:2;
}

.web_circle {
  border-radius: 10px;
  display: inline-block;
  height: 10px;
  margin-top: 20px;
  margin-left: 3px;
  width: 10px;
  background-color: #DDDDDD;
}

.web_circle:first-of-type {
  margin-left: 15px;
}

.web_bar {
  height: 10px;
}

.web_image {
  height: 140px;
  width: 100%;
  background-color: #eee;
  background-image: url("../../assets/images/houseimage.png");
}

.web_list {
  float: right;
  width: 320px;
}

.web_list ul {
  list-style-type: none;
}

.web_list ul li {
  line-height:2.0em;
  padding: 3px 0;
}

.web_list ul li i.icon {
  margin-left: -30px;
  margin-right: 20px;
}

.web_list.left {
  float:left;
  width: inherit;
}

.web_mock {
  border:1px solid #ddd;
  border-radius: 5px;
  width:430px;
  height:480px;
  left: 100px;
  position:relative;
  -webkit-box-shadow: 0px 7px 34px 2px rgba(219,216,219,1);
  -moz-box-shadow: 0px 7px 34px 2px rgba(219,216,219,1);
  box-shadow: 0px 7px 34px 2px rgba(219,216,219,1);
  z-index:0;
}
</style>
